$(function () {
  $('.form__wrapper input, .form__wrapper textarea').on(
    'change input',
    function () {
      $(this).parents('.form-input__container').find('.input-error').remove();
    }
  );
});

function sendContactForm() {
  var inputFirstName = $('#form-firstname');
  var inputLastName = $('#form-lastname');
  var inputEmail = $('#form-email');
  var inputMessage = $('#form-message');
  var inputTerms = $('#form-terms');
  var regionId = $('.form__wrapper--contact').attr('data-region-id');

  var error = false;

  $('.form__wrapper--contact .input-error').remove();
  $('.form__wrapper--contact .form-notice').remove();

  if (!inputFirstName.val()) {
    showInputError(inputFirstName, 'Bitte geben Sie Ihren Vorname ein');
    error = true;
  }

  if (!inputLastName.val()) {
    showInputError(inputLastName, 'Bitte geben Sie Ihren Nachname ein');
    error = true;
  }

  if (!inputEmail.val()) {
    showInputError(inputEmail, 'Bitte geben Sie Ihre E-Mail Adresse ein');
    error = true;
  }

  if (!inputMessage.val()) {
    showInputError(inputMessage, 'Bitte geben Sie Ihre Nachricht ein');
    error = true;
  }

  if (!inputTerms[0].checked) {
    showInputError(
      inputTerms,
      'Bitte akzeptieren Sie die Datenschutzbestimmungen'
    );
    error = true;
  }

  if (!error) {
    var input = {
      regionid: regionId,
      firstname: inputFirstName.val(),
      lastname: inputLastName.val(),
      email: inputEmail.val(),
      message: inputMessage.val()
    };

    $.ajax({
      url: '/form-contact',
      method: 'post',
      data: {
        input: input
      },
      headers: {
        'X-CSRF-TOKEN': $('#csrf-token').val()
      },
      beforeSend: function () {
        $('.form__wrapper input, .form__wrapper textarea, .form__wrapper button').attr('disabled', 'disabled');
        $('.form__wrapper button').addClass('loading-bar');
      },
      success: function (response) {
        $('.form__wrapper button').removeClass('loading-bar');
        if (response && response.success) {
          showFormSuccess($('.form__wrapper--contact'), 'Vielen Dank! Ihre Nachricht wurde abgeschickt');
          return;
        }
        $('.form__wrapper input, .form__wrapper textarea, .form__wrapper button').removeAttr('disabled');
        showFormError($('.form__wrapper--contact'), 'Fehler: Das Formular konnte nicht abgeschickt werden');
      },
      error: function () {
        $('.form__wrapper input, .form__wrapper textarea, .form__wrapper button').removeAttr('disabled');
        $('.form__wrapper button').removeClass('loading-bar');
        showFormError($('.form__wrapper--contact'), 'Fehler: Das Formular konnte nicht abgeschickt werden');
      }
    });
  }
}

function showInputError(el, msg) {
  var container = $(el).parents('.form-input__container');
  container.append($('<div class="input-error"/>').html(msg));
}

function showFormError(el, msg) {
  $(el).append($('<div class="form-notice form-notice--error"/>').html(msg));
}

function showFormSuccess(el, msg) {
  $(el).append($('<div class="form-notice form-notice--success"/>').html(msg));
}
